var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCrowdinCode } from './crowdin-languages';
import { doAsyncOperationWithRetry, getProccessedTranslations } from './utils';
const NUMBER_OF_ATTEMPTS = 3;
const HTTP_SUCCESS_CODE = 200;
export class TranslationsService {
    constructor({ locale, fallbackLocale, fallbackTranslations, scope, folderName, project, filename, }, config, apiClient) {
        this.subscriptions = new Map();
        this.translationFiles = new Map();
        this.syncTranslations = () => __awaiter(this, void 0, void 0, function* () {
            const { locale } = this;
            const query = {
                language: getCrowdinCode(locale),
                project: this.project || this.config.project,
                file: `${this.folderName || (this.scope && this.config.scopes[this.scope])}/${this.filename}`,
            };
            const response = yield doAsyncOperationWithRetry(() => this.apiClient
                .exportFileHttp(query)
                .then((res) => {
                if (res.status !== HTTP_SUCCESS_CODE) {
                    this.notifyListeners();
                    throw new Error(`HTTP error, status = ${res.status}`);
                }
                return res.body;
            })
                .catch(this.notifyListeners), NUMBER_OF_ATTEMPTS);
            if (response) {
                this.translationFiles.set(locale, response);
            }
            this.notifyListeners();
            return response;
        });
        this.setLocale = (locale) => {
            this.locale = locale;
            return this.syncTranslations();
        };
        this.getLocale = () => this.locale;
        this.onSync = (cb) => {
            this.subscriptions.set(cb, cb);
            return () => {
                this.subscriptions.delete(cb);
            };
        };
        this.getCurrentTranslations = () => {
            // we use english as fallback for non-translated keys
            return getProccessedTranslations(this.getTranslationsFile(this.locale) || {}, [
                this.fallbackTranslations['en-US'] || {},
                this.getFallbackTranslationsFile(),
            ]);
        };
        this.getFallbackTranslationsFile = () => {
            return (this.fallbackTranslations[this.locale] ||
                this.fallbackTranslations[this.fallbackLocale] ||
                this.fallbackTranslations['en-US'] ||
                {});
        };
        this.getTranslationsFile = (locale) => this.translationFiles.get(locale);
        this.notifyListeners = () => {
            this.subscriptions.forEach((cb) => cb(this.getCurrentTranslations()));
        };
        this.locale = locale;
        this.fallbackLocale = fallbackLocale;
        this.fallbackTranslations = fallbackTranslations;
        this.config = config;
        this.scope = scope;
        this.folderName = folderName;
        this.project = project;
        this.apiClient = apiClient;
        this.filename = filename !== null && filename !== void 0 ? filename : `translations.json`;
    }
}
